import React from 'react';
import classNames from 'classnames';
import {useTranslation} from 'react-i18next';
import {type TypedTranslation} from '../../../../i18n';

interface FormInputProps<T extends string | number | undefined> {
    type: 'text' | 'number' | 'password';
    name: string;
    value: T;
    onChange: (name: string, value: T) => void;
    label: string;
    placeholder?: string;
    errors?: string[];
    min?: number;
    disabled?: boolean;
}

function FormInput<T extends string | number | undefined>({
    type,
    name,
    value,
    onChange,
    label,
    placeholder,
    errors,
    min,
    disabled,
}: FormInputProps<T>): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className={classNames('c-field', {'is-invalid': errors})}>
            <label>
                {label}
                <div className="c-control  c-sidepanel__input">
                    <input
                        type={type}
                        className="e-input"
                        placeholder={placeholder || label}
                        value={value || ''}
                        name={name}
                        onChange={(e) => onChange(e.target.name, (type === 'number' ? parseInt(e.target.value) : e.target.value) as T)}
                        min={min}
                        disabled={disabled}
                    />
                </div>
            </label>

            {errors?.map((err) => (
                <div key={err} className="c-form-help is-invalid">
                    {t(err as TypedTranslation)}
                </div>
            ))}
        </div>
    );
}

export default FormInput;
